export const PortalSettingsGetSchema = {
  id: "id",
  pages: {
    general: {
      pageId: "general",
      smpName: "smpName",
      serviceDomainTimeZone: "serviceDomainTimeZone",
      isServiceDomainTimeZone: "isServiceDomainTimeZone",
    },
    certificates: {
      pageId: "certificates",
      dataList: "dataList",
      dataListSchema: {
        name: "name",
        dn: "dn",
        expirationDate: "expirationDate",
        fingerprint: "fingerprint",
      },
    },
    logging: {
      pageId: "logging",
      smcLogLevel: "smcLogLevel",
      smcLogLevelValues: {
        emergency: "EMERGENCY",
        alert: "ALERT",
        critical: "CRITICAL",
        error: "ERROR",
        warning: "WARNING",
        notice: "NOTICE",
        info: "INFO",
        debug: "DEBUG",
      },
      isSyslogClientEnabled: "isSyslogClientEnabled",
      syslogClientHost: "syslogClientHost",
      syslogClientPort: "syslogClientPort",
      isPurgeOldLogs: "isPurgeOldLogs",
      oldLogsDays: "oldLogsDays",
      isOldLogsArchive: "isOldLogsArchive",
    },
    dns: {
      pageId: "dns",
      domainSuffix: "domainSuffix",
      subDomain: "subDdnSuffix",
      dynamicIPTTL: "dynamicIPTTL",
      staticIPTTL: "staticIPTTL",
      ddnsEnabled: "ddnsEnabled",
      defaultDDNSDomain: "globalDDNSSuffix",
    },
    customFields: {
      pageId: "customFields",
      userCustomFields: "userCustomFields",
      gatewayCustomFields: "gatewayCustomFields",
      communityCustomFields: "communityCustomFields",
    },
    mail: {
      pageId: "mail",
      mailSupport: "mailSupport",
      mailSupportName: "mailSupportName",
    },
    firmware: {
      pageId: "firmware",
      availableFirmwares: "availableFirmwares",
      availableFirmwaresSchema: {
        name: "name",
        releaseDate: "releaseDate",
        schemaClientProduct: "schemaClientProduct",
        clientVersion: "clientVersion",
        firmDescription: "firmDescription",
        type: "type",
      },
    },
    notificationGateways: {
      pageId: "notificationGateways",
      gatewayAddedOrChanged: "gatewayAddedOrChanged",
      gatewayNotConnected: "gatewayNotConnected",
      gatewayNotConnectedSchema: {
        gatewayNotConnectedMins: "gatewayNotConnectedMins",
        gatewayNotConnectedDays: "gatewayNotConnectedDays",
        gatewayNotConnectedAtHour: "gatewayNotConnectedAtHour",
        gatewayNotConnectedIsMins: "gatewayNotConnectedIsMins",
        notifySubscriptEndInDays: "notifySubscriptEndInDays",
        gatewayLoginFailuresNum: "gatewayLoginFailuresNum",
        gatewayLoginFailuresMins: "gatewayLoginFailuresMins",
      },
    },
    notificationGatewaysReports: {
      pageId: "notificationGatewaysReports",
      client3DReport: "client3DReport",
      japaneseClient3DReport: "japaneseClient3DReport",
      hebrewClient3DReport: "hebrewClient3DReport",
      germanClient3DReport: "germanClient3DReport",
      companyDetails: "companyDetails",
      companyDetailsSchema: {
        primaryLogoId: "primaryLogoId",
        secondaryLogoId: "secondaryLogoId",
        enablePrimaryLogo: "enablePrimaryLogo",
        enableSecondaryLogo: "enableSecondaryLogo",
        customText: "customText",
      },
      reportsEditPermission: "reportsEditPermission",
    },
    notificationUsers: {
      pageId: "notificationUsers",
      userAddedOrChanged: "userAddedOrChanged",
    },
    notificationSummaryMessages: {
      pageId: "notificationSummaryMessages",
      userSummary: "userSummary",
      communitySummary: "communitySummary",
      generalMessage: "generalMessage",
    },
    notificationReports: {
      pageId: "notificationReports",
      summaryReport: "summaryReport",
      summaryReportSchema: {
        reportsUnits: "summaryReportsUnits",
        reportsUnitsValues: {
          daily: "Daily",
          weekly: "Weekly",
          monthly: "Monthly",
        },
        summaryReportsDayNumber: "summaryReportsDayNumber",
      },
    },
    customAlerts: {
      pageId: "customAlerts",
      alertList: "alertList",
    },
    twoStepAuth: {
      pageId: "twoStepAuth",
      isTwoFactorAuth: "isTwoFactorAuth",
    },
    apiAccess: {
      pageId: "apiAccess",
      apiAccessMethod: "apiAccessMethod",
      apiAccessMethodValues: {
        any: "Any",
        restricted: "Restricted",
      },
      dataList: "dataList",
      dataListSchema: {
        ipAddr: "ipAddr",
        subnetMask: "subnetMask",
        domainName: "domainName",
        type: "type",
      },
    },
    radiusAuth: {
      pageId: "radiusAuth",
      radiusPrimaryHostIP: "radiusPrimaryHostIP",
      radiusPrimarySecret: "radiusPrimarySecret",
      radiusSecondaryHostIP: "radiusSecondaryHostIP",
      radiusSecondarySecret: "radiusSecondarySecret",
      radiusPort: "radiusPort",
      radiusUserName: "radiusUserName",
      radiusUserPassword: "radiusUserPassword",
    },
    userPasswordSecurity: {
      pageId: "userPasswordSecurity",
      userPasswordEnforceLength: "userPasswordEnforceLength",
      userPasswordEnforceRenewal: "userPasswordEnforceRenewal",
      userPasswordEnforceRenewalPeriod: "userPasswordEnforceRenewalPeriod",
      userPasswordLengthMin: "userPasswordLengthMin",
      userPasswordLengthMax: "userPasswordLengthMax",
      userPasswordReuseChars: "userPasswordReuseChars",
      userPasswordReuseCharsLength: "userPasswordReuseCharsLength",
      userPasswordDontReuseByNumber: "userPasswordDontReuseByNumber",
      userPasswordDontReuseByNumberVal: "userPasswordDontReuseByNumberVal",
      userPasswordDontReuseByTime: "userPasswordDontReuseByTime",
      userPasswordDontReuseByTimeVal: "userPasswordDontReuseByTimeVal",
      userPasswordNoWhitespaces: "userPasswordNoWhitespaces",
      userPasswordNotUID: "userPasswordNotUID",
      userPasswordRepeatingChars: "userPasswordRepeatingChars",
      userPasswordRepeatingCharsVal: "userPasswordRepeatingCharsVal",
      userPasswordComplexity: "userPasswordComplexity",
      userPasswordComplexityNumRules: "userPasswordComplexityNumRules",
      userPasswordComplexityUppercase: "userPasswordComplexityUppercase",
      userPasswordComplexityLowercase: "userPasswordComplexityLowercase",
      userPasswordComplexityNumbers: "userPasswordComplexityNumbers",
      userPasswordComplexitySpecialChars: "userPasswordComplexitySpecialChars",
    },
    domainCyberReports: {
      pageId: "domainCyberReports",
      domainCyberReportsActivation: "domainCyberReportsActivation",
      domainCyberReportsDaily: "domainCyberReportsDaily",
      domainCyberReportsDailyTime: "domainCyberReportsDailyTime",
      domainCyberReportsWeekly: "domainCyberReportsWeekly",
      domainCyberReportsWeekday: "domainCyberReportsWeekday",
      domainCyberReportsWeekdayTime: "domainCyberReportsWeekdayTime",
      domainCyberReportsMonthly: "domainCyberReportsMonthly",
      domainCyberReportsMonthDay: "domainCyberReportsMonthDay",
      domainCyberReportsMonthTime: "domainCyberReportsMonthTime",
      domainCyberReportsContactRecipient: "domainCyberReportsContactRecipient",
      domainCyberReportsAdditionalEmails: "domainCyberReportsAdditionalEmails",
      domainCyberReportsAdditionalEmailsStr:
        "domainCyberReportsAdditionalEmailsStr",
    },
  },
};
